import { boot, shutdown, update, show, Intercom } from '@intercom/messenger-js-sdk';

export const useIntercom = () => {
	const setAppId = (appId: string) => {
		Intercom({ app_id: appId });
	};

	return {
		setAppId,
		boot,
		shutdown,
		update,
		show,
	};
};
